<script lang="ts">
  /** The sofa mark (back in ink, seat in coral) and the lowercase wordmark. */
  let { size = 22, wordmark = true }: { size?: number; wordmark?: boolean } = $props()
</script>

<span class="brand-lockup" style="--s: {size}px">
  <span class="sofa-mark" aria-hidden="true"><i></i><b></b></span>
  {#if wordmark}<span class="brand-lockup__word">sofa</span>{/if}
</span>
